import { SelectData } from "../../../../../../models";

export const CLOSE_DEAL_STATUS_OPTIONS: SelectData = [
  { key: "Approved", value: "Approved" },
  { key: "Rejected", value: "Rejected" },
];

export const CLOSE_DEAL_REASON_OPTIONS: SelectData = [
  { key: "Not now", value: "Not now" },
  { key: "Out of scope", value: "Out of scope" },
  { key: "Not a fit", value: "Not a fit" },
  { key: "Not qualified", value: "Not qualified" },
  { key: "Out of budget", value: "Out of budget" },
  { key: "Lost momentum", value: "Lost momentum" },
  { key: "Misalignment with criteria", value: "Misalignment with criteria" },
  { key: "Insufficient documentation", value: "Insufficient documentation" },
  { key: "Financial Risk", value: "Financial Risk" },
  { key: "Operational Risk", value: "Operational Risk" },
];
